goog.provide("shadow.js.shim.module$src$svg$shapes$rectangle$rectangle_viewfinder_svg$default");
shadow.js.shim.module$src$svg$shapes$rectangle$rectangle_viewfinder_svg$default = shadow.js.shim.module$src$svg$shapes$rectangle$rectangle_viewfinder_svg.default;
